import React from 'react';
import { useEvaluationModal } from '@/components/EvaluationModal/useEvaluationModal';
import { EvaluationValueBadge } from '@/components/EvaluationValueBadge';
import { RatingChip, ScaleChip } from '@/components/Icons/MarkChipIcons';
import { LessonTypeChip } from '@/components/LessonTypeChip';
import type { DiaryEvaluation } from '@/types/diary';

const DEFAULT_CLASS_NAME = 'flex min-w-0 flex-1 flex-col gap-3 py-2 pr-3 pl-4';

interface Props {
  evaluations: DiaryEvaluation[];
  className?: string;
  itemClassName?: string;
}

export const DiaryEvaluations: React.FC<Props> = ({
  evaluations,
  className = DEFAULT_CLASS_NAME,
  itemClassName,
}) => {
  const { onOpen } = useEvaluationModal();

  return (
    <div className={className}>
      {evaluations.map((evaluation) => (
        <button
          key={evaluation.id}
          type="button"
          className={`flex min-w-0 cursor-pointer flex-col gap-2 text-left ${itemClassName ?? ''}`}
          onClick={() => onOpen(evaluation.id)}
        >
          <span className="flex w-full items-center justify-between gap-2">
            <LessonTypeChip
              name={evaluation.lessonTypeName}
              lessonTypeId={evaluation.lessonTypeId}
            />
            <EvaluationValueBadge
              value={evaluation.value}
              previousValue={evaluation.previousValue}
              lessonTypeId={evaluation.lessonTypeId}
              nonAttendanceType={evaluation.nonAttendanceType}
              isNonAttendance={evaluation.isNonAttendance}
            />
          </span>

          {(evaluation.isWeighted || evaluation.isTest) && (
            <span className="flex items-center gap-1">
              {evaluation.isWeighted && <ScaleChip />}
              {evaluation.isTest && <RatingChip />}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};
